import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './feature/App';
import { Provider } from 'react-redux';
import configureStore from './redux/configureStore';
import initialState from './redux/initialState';
import { PersistGate } from 'redux-persist/integration/react';
import LinearProgress from '@material-ui/core/LinearProgress';
import * as serviceWorker from './serviceWorker';
require('dotenv').config();

export const reduxStore = configureStore(initialState);

const render = (Component) => {
  ReactDOM.render(
    <Provider store={reduxStore.store}>
      <PersistGate loading={<LinearProgress />} persistor={reduxStore.persistor}>
        <App />
      </PersistGate>
    </Provider>,
    document.getElementById('root')
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./feature/App', () => {
    const NextApp = require('./feature/App').default;
    render(NextApp);
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
